import * as ChartJS from 'chart.js/auto';

export const VerticalLinePlugin = {
  id: 'verticalLines',
  afterDraw: (chart: ChartJS.Chart) => {
    // @ts-expect-error custom plugin options
    const lines = chart.options.plugins?.verticalLines;
    if (!lines || !Array.isArray(lines)) {
      return;
    }

    const ctx = chart.ctx;
    const xAxis = chart.scales.x;
    const yAxis = chart.scales.y;

    lines.forEach(lineOptions => {
      if (lineOptions.x === undefined) {
        return;
      }

      // Get pixel location for the x value
      const x = xAxis.getPixelForValue(lineOptions.x);

      if (x < xAxis.left || x > xAxis.right) {
        return; // Don't draw if outside of the chart area
      }

      ctx.save();

      // Line properties
      ctx.beginPath();
      ctx.moveTo(x, yAxis.top);
      ctx.lineTo(x, yAxis.bottom);
      ctx.lineWidth = lineOptions.lineWidth || 1;
      ctx.strokeStyle = lineOptions.color || 'red';
      if (lineOptions.dash) {
        ctx.setLineDash(lineOptions.dash); // e.g., [5, 5] for a dotted line
      }

      ctx.stroke();
      ctx.restore();
    });
  }
};

export const LegendMarginPlugin = {
  id: 'legendMargin',
  beforeInit(chart: ChartJS.Chart) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const originalFit = (chart.legend as ChartJS.LegendElement<any>).fit;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (chart.legend as ChartJS.LegendElement<any>).fit = function fit() {
      originalFit.bind(this)();
      this.height += 30; // This adds 30px of space below the legend
    };
  }
};
